import { render } from "./standardBrain.vue?vue&type=template&id=623b4e68&scoped=true"
import script from "./standardBrain.vue?vue&type=script&lang=js"
export * from "./standardBrain.vue?vue&type=script&lang=js"

import "./standardBrain.vue?vue&type=style&index=0&id=623b4e68&scoped=true&lang=css"

import exportComponent from "D:\\code\\humanbrainview\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-623b4e68"]])

export default __exports__